
<div class="flow-radio-wrapper" :alignItems="alignItems" :disabled="disabled">
	<div
		class="flow-radio"
		:tabindex="tabindex"
		:checked="innerChecked"
		:disabled="disabled"
		:state="state"
		:size="size"
		:data-qa-field="dataQaField"
		@click="handleClick($event)"
	>
		<svg v-if="innerChecked" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
			<path d="M6,13.223,8.45,16.7a1.049,1.049,0,0,0,1.707.051L18,6.828" />
		</svg>
	</div>
	<div class="flow-radio-label" @click="handleClick($event)">
		<!-- @slot Used to display radio button label-->
		<slot />
	</div>
</div>
